import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import {
  light,
  // grey,
  dark,
  disabledColor,
  backgroundColor,
  primaryColor,
  primaryColorLight,
  secondaryColor,
  tercaryColor,
  tercaryColorLight,
  bodyColor,
  titleColor,
} from 'helpers/colors';
export default class Theme extends React.Component {
  render() {
    const { children } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: primaryColor,
          light: primaryColorLight,
        },
        secondary: {
          main: secondaryColor,
        },
        tercary: {
          main: tercaryColor,
          // light: '#dddedc',
          light: tercaryColorLight,
        },
        text: {
          primary: dark,
          secondary: secondaryColor,
          light,
          dark,
        },
        action: {
          disabled: disabledColor,
        },
        background: {
          default: backgroundColor,
        },
      },
      typography: {
        fontFamily: ['Montserrat, Helvetica, Arial, sans-serif'].join(','),
        useNextVariants: true,
        h1: {
          // color: titleColor || light,
          // fontWeight: "bold",
          // display: "inline-block",
          // letterSpacing: 2,
          color: dark,
          backgroundColor: tercaryColor,
          fontSize: '1.8rem',
          fontWeight: 'bold',
          padding: '20px 30px',
          textAlign: 'left',
          marginBottom: 5,
        },
        h2: {
          textAlign: 'center',
          color: titleColor || light,
          // fontWeight: 'bold',
          // lineHeight: 0.95,
          letterSpacing: 1.8,
        },
        h3: {
          color: dark,
          backgroundColor: tercaryColor,
          fontSize: '1.8rem',
          fontWeight: 'bold',
          padding: '80px 30px',
          textAlign: 'left',
          marginBottom: 5,
        },
        h4: {
          color: primaryColor,
          fontSize: '1.2rem',
          fontWeight: 'bold',
          marginBottom: 24,
        },
        h5: {
          color: dark,
          fontSize: '1.2rem',
          fontWeight: 'bold',
          marginBottom: 24,
        },
        body1: {
          fontSize: '1rem',
          color: dark,
        },
        body2: {
          fontSize: '1rem',
          color: secondaryColor,
        },
        subtitle1: {
          color: primaryColor,
          fontSize: '1rem',
        },
        subtitle2: {
          color: secondaryColor,
          fontSize: '1rem',
        },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      overrides: {
        MuiButton: {
          root: {
            '&.MuiButton-contained': {
              color: dark,
              backgroundColor: '#fff',
              fontWeight: 'bold',
            },
            '&.MuiButton-sizeLarge': {
              padding: '8px 50px',
              fontSize: '22px',
            },
            '&.MuiButton-containedSizeLarge': {
              padding: '8px 50px',
              fontSize: '22px',
            },
            '&.MuiButton-outlinedSecondary': {
              backgroundColor: light,
              '&:hover': {
                color: light,
                backgroundColor: secondaryColor,
              },
            },
            '&.MuiButton-containedSecondary': {
              border: '1px solid transparent',
              backgroundColor: secondaryColor,
              color: light,
              '&:hover': {
                border: '1px solid rgba(0, 102, 157, 0.5)',
                color: secondaryColor,
                backgroundColor: light,
              },
            },
            '&.MuiButton-containedPrimary': {
              border: '1px solid transparent',
              color: light,
              backgroundColor: primaryColor,
              '&:hover': {
                border: '1px solid '.primaryColor,
                color: primaryColor,
                backgroundColor: light,
              },
            },
          },
        },
        MuiFormHelperText: {
          root: {
            color: bodyColor,
          },
        },
        // "MuiStepper-root": {
        //   padding: 0,
        // },
        MuiStep: {
          root: {
            '& > .MuiStepConnector-root': {
              display: 'none',
            },
          },
        },
        MuiFilledInput: {
          root: {
            backgroundColor: '#fff',
            '&$focused': {
              backgroundColor: '#fff',
            },
            '&:hover': {
              backgroundColor: '#fff',
            },
          },
          underline: {
            '&:before': {
              borderBottomColor: primaryColorLight,
            },
            '&:before:hover': {
              borderBottomColor: primaryColor,
            },
          },
        },
      },
    });
    theme.typography.h1 = {
      ...theme.typography.h1,
      // [theme.breakpoints.up("xs")]: {
      //   fontSize: "2rem",
      //   textAlign: 'center'
      //   // padding: '20px'
      // },
      // [theme.breakpoints.up("sm")]: {
      //   fontSize: "2.8rem",
      //   textAlign: 'center'
      // },
      // [theme.breakpoints.up("md")]: {
      //   fontSize: "3.2rem",
      // },
      // [theme.breakpoints.up("lg")]: {
      //   fontSize: "4rem",
      // },
      // [theme.breakpoints.up("xl")]: {
      //   fontSize: "4.5rem",
      // },
    };
    theme.typography.h2 = {
      ...theme.typography.h2,
      [theme.breakpoints.up('xs')]: {
        fontSize: '1.4rem',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
      [theme.breakpoints.up('md')]: {
        fontSize: '2rem',
      },
      // [theme.breakpoints.up("lg")]: {
      //   fontSize: "2.8rem",
      // },
      // [theme.breakpoints.up("xl")]: {
      //   fontSize: "3.2rem",
      // },
    };
    theme.typography.h6 = {
      ...theme.typography.h6,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    };
    theme.overrides['MuiContainer'] = {
      fixed: {
        [theme.breakpoints.down('lg')]: {
          maxWidth: '100%',
        },
      },
    };
    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx